/**
 * Hair Salon screen (hair_salon tool): the shared style-template screen with an
 * optional hair color step. See ./styleTool.ts.
 */
import { renderStyleTool } from './styleTool.js';
import { hairOptions } from './toolOptions.js';

export function renderHairSalon(root: HTMLElement, query: URLSearchParams): void {
  renderStyleTool(root, query, {
    tool: 'hair_salon',
    title: 'Hair Salon',
    subtitle: 'Try new hairstyles and colors with AI.',
    stylesTitle: 'Choose a hairstyle',
    seeAllHref: '#/category/hair-salon',
    cta: 'Generate Hair Style',
    emptyIcon: 'content_cut',
    emptyText: 'No hairstyles are available yet. Please check back soon.',
    makeOptions: hairOptions,
  });
}
